import React from "react";
import "./reasons.css";
import image1 from "../../assets/image1.png";
import image2 from "../../assets/image2.png";
import image3 from "../../assets/image3.png";
import image4 from "../../assets/image4.png";
import nb from "../../assets/nb.png";
import adidas from "../../assets/adidas.png";
import nike from "../../assets/nike.png";
import tick from "../../assets/tick.png";

const Reasons = () => {
  return (
    <div className="Reasons" id="reasons">
      {/* Left Side - Images */}
      <div className="left-r">
        <img src={image1} alt="Strength Training" />
        <img src={image2} alt="Focused Workouts" />
        <img src={image3} alt="State-of-the-Art Gym" />
        <img src={image4} alt="Endurance Training" />
      </div>

      {/* Right Side - Content */}
      <div className="right-r">
        <span>Why Choose Us?</span>

        <div>
          <span className="stroke-text">Your </span>
          <span>Path to Excellence</span>
        </div>

        <div className="details-r">
          <div>
            <img src={tick} alt="Tick" />
            <span>World-Class Certified Trainers to Guide You</span>
          </div>
          <div>
            <img src={tick} alt="Tick" />
            <span>Cutting-Edge Equipment for Maximum Performance</span>
          </div>
          <div>
            <img src={tick} alt="Tick" />
            <span>Supportive Community that Keeps You Motivated</span>
          </div>
          <div>
            <img src={tick} alt="Tick" />
            <span>Flexible Membership Plans Tailored to Your Needs</span>
          </div>
        </div>

        {/* Partners Section */}
        <span style={{ color: "var(--gray)", fontWeight: "normal" }}>
          Trusted by the Best
        </span>

        <div className="partners">
          <img src={nb} alt="New Balance" />
          <img src={adidas} alt="Adidas" />
          <img src={nike} alt="Nike" />
        </div>
      </div>
    </div>
  );
};

export default Reasons;
